import * as urlUtils from 'utils/Url';
import { getAuth } from 'api/Utils';

export * from './Accounts';
export * from './Alerts';
export * from './Billing';
export * from './Broadcasts';
export * from './Control';
export * from './Contacts';
export * from './Custom';
export * from './Data';
export * from './Ecommerce';
export * from './Emails';
export * from './Extensions';
export * from './Jobs';
export * from './Partners';
export * from './Reviews';
export * from './Resources';
export * from './Organizations';
export * from './Sources';
export * from './Users';
export * from './Webhooks';
export * from './Workflows';



const noop = () => {};

export function getConsoleContext(successCallback, errorCallback) {
  getAuth({
    "path": `view/get-console-context`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewOAuthLoginDetails(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/oauth-login-details`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewAccountPrompt(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/account-prompt`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewStoreConnectionExists(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/store-connection-exists`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewDuplicateConnectionExists(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/duplicate-connection-exists`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewMarketingPlatformOverview(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/marketing-platform-overview`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewMarketingPlatformAnalytics(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/marketing-platform-analytics`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewManageCatalog(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-catalog`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getDynamicDropdown(successCallback, errorCallback, headers={}, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`dynamic-dropdown`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "headers": headers
  });
}

export function getDynamicDisplay(successCallback, errorCallback, headers={}, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`dynamic-display`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "headers": headers
  });
}

export function getWsBaseUrl(path) {
  const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";
  return `${protocol}${window.location.host}/ws`;
}
